import {combineReducers} from 'redux'
import tourEventResultsData from './tour_event_results_data'

export default combineReducers({
  tourEventResultsData,
})
